import React from 'react';
import DemoHeader from '../ui/demo-header';
import DemoFooter from '../ui/landing-footer';

const DemoShell = ({children}) => {
    return (
        <div className='h-[100vh] overflow-y-scroll scrollbar-none w-screen bg-white-50'>
            {children}
        </div>
    );
};

export default DemoShell;